import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import LinkButton from '../Models/LinkButton/LinkButton';
import Image from '../Models/Image/Image';
import css from './VisitOurWebsiteBlock.module.scss';
import Button from '../Button/Button';

const VisitOurWebsiteBlock = ({
    lang,
    logo,
    link
}) => {
    return (
        <div className={cn(css.block, {
            [css['no-logo']]: !(logo) 
        })}>
            <div className={css.container}>
                {logo &&
                <div className={css['logo-container']}>
                    <img className={css.logo} src={logo.url} alt={logo.altText ? logo.altText : ''} />
                </div>}
                <div className={css['text-container']}>
                    <h2 className={css['name']}>{lang.visitOurWebsiteLabel}</h2>
                    { link && link.url && <Button 
                        className={css['button']}
                        href={link.url}
                        target={link.target}
                        secondary
                    >{link.text}</Button> }
                </div>
            </div>
        </div>
    );
};

VisitOurWebsiteBlock.propTypes = {
    lang: PropTypes.shape({
        visitOurWebsiteLabel: PropTypes.string.isRequired
    }).isRequired,
    logo: PropTypes.shape(Image.propTypes),
    link: PropTypes.shape(LinkButton.propTypes)
};

export default VisitOurWebsiteBlock;



// WEBPACK FOOTER //
// ./src/components/VisitOurWebsiteBlock/VisitOurWebsiteBlock.jsx